import axios from "axios";
import { generateEscherSignedUrl } from "../helpers/escher";
import { isLocalMode } from "../helpers/envHelper";

export default class sessionApi {
  static async getJwt(url) {
    var finalUrl;
    if (isLocalMode()) {
      finalUrl = this.getTargetUrlInLocalMode(url);
    } else {
      finalUrl = url;
    }

    const params = {
      iid: `${process.env.REACT_APP_IFRAME_HANDSHAKE_CLIENT_ID}`,
      url: finalUrl
    };

    const requestUrl = `${process.env.REACT_APP_LOYALTY_API}/iframe-handshake`;

    const response = await axios.get(requestUrl, { params });

    const { jwtToken } = response.data;

    return jwtToken;
  }

  static getTargetUrlInLocalMode(url) {
    const forcedUrl = url.replace("http://localhost:3001/", process.env.REACT_APP_TARGET_URL_IN_LOCAL_MODE);

    var id = "id" + Math.random().toString(16).slice(2);
    let appendUrl =
      forcedUrl + "&msid=local_" + id + "&showMenuBar=true&admin_id=" + process.env.REACT_APP_LOCAL_ADMIN_ID;
    return generateEscherSignedUrl(appendUrl);
  }
}
